import type { TContactParam } from '@cian/newbuilding-chat-component';

import { actionGenerator } from '../../utils/actionGenerator';

export enum EBuilderChatActionTypes {
  OpenChat = 'builderChat/open',
  CloseChat = 'builderChat/close',
  SetBuilderChatButtonClicked = 'builderChat/setBuilderChatButtonClicked',
}

export interface IOpenBuilderChatPayload {
  chatContact: TContactParam;
  gaLabel: string;
}

export const openBuilderChat = actionGenerator<EBuilderChatActionTypes.OpenChat, IOpenBuilderChatPayload>(
  EBuilderChatActionTypes.OpenChat,
);

export const closeBuilderChat = actionGenerator<EBuilderChatActionTypes.CloseChat, void>(
  EBuilderChatActionTypes.CloseChat,
);

export const setBuilderChatButtonClicked = actionGenerator<EBuilderChatActionTypes.SetBuilderChatButtonClicked, void>(
  EBuilderChatActionTypes.SetBuilderChatButtonClicked,
);

export type TBuilderChatActions =
  | ReturnType<typeof openBuilderChat>
  | ReturnType<typeof closeBuilderChat>
  | ReturnType<typeof setBuilderChatButtonClicked>;
